// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@gcg/XDL/Helpers";
import { xBaseTheme } from "@gcg/XDL/types";
import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        cssOverrides: {
            datePicker: css`
                .react-datetime-picker {
                    padding: 1px 10px 1px 10px;
                    .react-datetime-picker__inputGroup {
                        order: 2;

                        input[class*="react-datetime-picker__inputGroup__input"] {
                            ${screen("lte", "xs")` padding: 1px 2px; `}
                        }
                    }
                    .react-datetime-picker__clear-button {
                        order: 3;
                        > span {
                            padding-right: 0;

                            svg {
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                    .react-datetime-picker__calendar-button {
                        order: 1;
                        > span {
                            padding-left: 0;
                            outline: 0;

                            svg {
                                width: 18px;
                                height: 18px;
                            }
                        }
                    }
                }
                .react-calendar {
                    max-width: 280px;
                    width: 280px;
                    .react-calendar__navigation {
                        font-size: 16px;
                        line-height: 18px;
                        letter-spacing: 0.5px;
                        font-weight: 600;
                        display: flex;
                    }

                    .react-calendar__navigation__arrow {
                        background-size: 18px;
                    }

                    .react-calendar__month-view__weekdays__weekday abbr {
                        font-weight: 600;
                    }

                    .react-calendar__tile {
                        abbr {
                            font-size: 12px;
                            color: ${getColor("text.main")};
                        }

                        &.react-calendar__tile--now {
                            outline: 1px solid ${getColor("warning.main")};
                            abbr {
                                color: ${getColor("text.main")};
                                &:after {
                                    content: none;
                                }
                            }
                        }

                        &.react-calendar__tile--active {
                            abbr {
                                color: ${getColor("common.white")};
                            }
                        }
                        &[disabled] abbr {
                            color: ${getColor("common.ui4")};
                        }
                    }
                    &__month-view__days__day {
                        border-radius: 0;
                    }
                    &__tile {
                        &--now {
                            position: relative;
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
